import { render } from "./ButtonBookDemo.vue?vue&type=template&id=7e595859"
import script from "./ButtonBookDemo.vue?vue&type=script&lang=js"
export * from "./ButtonBookDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__